<template>
  <sweet-modal blocking :title="title" ref="modal" class="modal" v-on:close="closeModal">
    <el-form
        :model="form"
        size="mini"
        label-width="115px"
        ref="form"
        status-icon>
      <el-table
          max-height="650"
          :data="form.list"
          size="mini"
          border
          style="width: 100%"
          :empty-text="$t('general_noData')">
        <el-table-column
            prop="formNo"
            width="130"
            label="Form No.">
          <template slot-scope="scope">
            <el-form-item
                label-width="0"
                :prop="'list.' + scope.$index + '.adminReportingFormId'"
                :rules="{
                  required: true, message: 'Field is required', trigger: 'blur'
                }">
              <el-select :disabled="readonly" v-model="scope.row.adminReportingFormId" size="mini">
                <el-option v-for="item in adminReportingFormList"
                           :key="item.id"
                           :label="item.formNo"
                           :disabled="item.disabled"
                           :value="item.id"
                           @click.native="selectReport(item, scope.row)">
                </el-option>
              </el-select>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column
            prop="name"
            width="200"
            label="Name">
          <template slot-scope="scope">
            <div>
              {{ scope.row.name }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
            prop="description"
            label="Description">
          <template slot-scope="scope">
            <div>
              {{ scope.row.description }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
            prop="description"
            width="200"
            label="Frequency">
          <template slot-scope="scope">
            <el-select :disabled="readonly" v-model="scope.row.frequency" size="mini">
              <el-option v-for="item in frequencyList"
                         :key="item"
                         :lanel="item"
                         :value="item">
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
            prop="dueDate"
            width="180"
            label="Due Dates">
          <template slot-scope="scope">
            <el-form-item
                :prop="'list.' + scope.$index + '.dueDates'"
                label-width="0"
                style="margin-bottom: 0;"
                :rules="{
                  required: true, message: 'Field is required', trigger: 'blur'
                }"
                size="mini">
              <el-date-picker
                  :readonly="readonly"
                  v-model="scope.row.dueDates"
                  type="date"
                  format="d MMM yy"
                  value-format="ddMMyyyy"
                  style="width: 100%;">
              </el-date-picker>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column
            v-if="!readonly"
            width="65">
          <template slot-scope="scope">
            <el-button
                @click="() => form.list.splice(scope.$index, 1)"
                size="mini"
                plain>
              <i class="fas fa-trash"></i>
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
    <div v-if="!readonly" style="display: flex; width: 100%; justify-content: flex-end; margin-top: 20px;">
      <el-button
          size="mini"
          type="primary"
          plain
          style="margin-right: 10px"
          @click="addLine">Add Line</el-button>
      <el-button
          size="mini"
          type="primary"
          plain
          @click="save">Add Form</el-button>
    </div>
  </sweet-modal>
</template>

<script>
import { SweetModal } from '@totalflow4/tfsweet-modal-vue'
import axios from 'axios'
export default {
  name: "FillingTablesModal",
  components: {
    SweetModal
  },
  props: {
    readonly: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    companyLayout() {
      return this.$store.getters.getCompanyLayout
    },
  },
  data: vm => vm.initialState(),
  methods: {
    async openModal(entityTypeId) {
      this.entityTypeId = entityTypeId
      switch (entityTypeId) {
        case '71' :
          this.title = 'VAT / Percentage'
          break;
        case '72' :
          this.title = 'Withholding Tax'
          break;
        case '73' :
          this.title = 'Income Tax'
          break;
        case '74' :
          this.title = 'Branch Office Forms'
          break;
        case '75' :
          this.title = 'Misc / Others'
          break;
        default:
          this.title = 'VAT / Percentage'
      }
      const loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      const adminReporting = await axios.post(`/api/v1/admin-reporting-forms/list?countryId=${this.companyLayout.countryId}&entityTypeId=${entityTypeId}`)
      this.adminReportingFormList = adminReporting.data.list
      const { data } = await axios.get(`/api/v1/bir-filling-tables/item?companyId=${this.$route.query.companyId}&entityTypeId=${entityTypeId}`)
      this.form.list = data.list.map(val => ({
        adminReportingFormId: val.adminReportingFormId,
        name: val.name,
        description: val.adminReportingForms ? val.adminReportingForms.description : null,
        frequency: val.frequency,
        dueDates: val.dueDates.toString(),
      }))
      loader.hide()
      this.$refs.modal.open()
    },
    addLine() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.form.list.push({
            adminReportingFormId: null,
            name: null,
            description: null,
            frequency: null,
            dueDates: null,
          })
        }
      })
    },
    selectReport(item, row) {
      row.name = item.name
      row.description = item.description
      row.frequency = item.frequency
    },
    save() {
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          const loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          const payload = {
            itemList: this.form.list.map(val => ({...val, entityTypeId: this.entityTypeId}))
          }
          await axios.post(`/api/v1/bir-filling-tables/save?companyId=${this.$route.query.companyId}&entityTypeId=${this.entityTypeId}`, payload)
          this.$refs.modal.close()
          loader.hide()
        }
      })
    },
    closeModal() {
      this.$refs['form'].resetFields();
      this.initialState()
    },
    initialState() {
      return {
        title: null,
        entityTypeId: null,
        form: {
          list: [],
        },
        frequencyList: [
          'Monthly',
          'Quarterly',
          'Annually'
        ],
        adminReportingFormList: []
      }
    }
  },
  watch: {
    'form.list': {
      handler(val) {
        if (val.length) {
          this.adminReportingFormList = this.adminReportingFormList.map(item => ({...item, disabled: !!val.find(item2 => item2.adminReportingFormId === item.id)}))
        }
      },
      deep: true,
    }
  }
}
</script>

<style scoped>

</style>
